import React, { createContext, useContext, useState, useEffect } from 'react';
import { logger } from '../utils/logger';

const B2BAuthContext = createContext();

export const useB2BAuth = () => {
  const context = useContext(B2BAuthContext);
  if (!context) {
    throw new Error('useB2BAuth must be used within B2BAuthProvider');
  }
  return context;
};

export const B2BAuthProvider = ({ children }) => {
  const [b2bCustomer, setB2BCustomer] = useState(null);
  const [b2bLoading, setB2BLoading] = useState(true);

  useEffect(() => {
    // Check if B2B customer is logged in
    const token = localStorage.getItem('b2b_token');
    const customerData = localStorage.getItem('b2b_customer');
    
    if (token && customerData) {
      try {
        setB2BCustomer(JSON.parse(customerData));
      } catch (error) {
        logger.error('Failed to parse B2B customer data:', error);
        localStorage.removeItem('b2b_token');
        localStorage.removeItem('b2b_customer');
      }
    }
    
    setB2BLoading(false);
  }, []);

  const b2bLogin = (token, customer, customerType) => {
    localStorage.setItem('b2b_token', token);
    localStorage.setItem('b2b_customer', JSON.stringify(customer));
    localStorage.setItem('b2b_customer_type', JSON.stringify(customerType));
    setB2BCustomer(customer);
  };

  const b2bLogout = () => {
    localStorage.removeItem('b2b_token');
    localStorage.removeItem('b2b_customer');
    localStorage.removeItem('b2b_customer_type');
    setB2BCustomer(null);
  };

  const value = {
    b2bCustomer,
    b2bLoading,
    b2bLogin,
    b2bLogout,
    isB2BLoggedIn: !!b2bCustomer
  };

  return (
    <B2BAuthContext.Provider value={value}>
      {children}
    </B2BAuthContext.Provider>
  );
};
